
import Device from './device'
import Staff from './staff'
import Order from './order'
import Type from './type'
import Recharge from './recharge'
import Wrap from '@/views/Wrap'
import Main from '@/views/shop/Main'
import Login from '@/views/shop/Login'
import dashboard from '@/views/dashboard'
import password from '@/views/shop/password'

export default {
    path: "/shop",
    name: "平台",
    component: Wrap,
    redirect: "shop/main",
    meta: { hideInBreadcrumb: true },
    children: [
        {
            path: 'login/',
            name: '登录',
            component: Login
        },
        {
            path: 'main',
            name: '首页',
            component: Main,
            redirect: 'main/index',
            children: [
                {
                    name: '主页',
                    path: 'index',
                    meta: { hideBreadcrumb: true },
                    component: dashboard
                },
                {
                    name: '修改密码',
                    path: 'password',
                    meta: { hideBreadcrumb: false },
                    component: password
                },
                Device,
                Type,
                Staff,
                Order,
                Recharge
            ]
        }
    ]
}


// WEBPACK FOOTER //
// ./src/router/shop/index.js